import styled from 'styled-components';

//helpers
import {borderRadius, cardShadowCss} from 'styles/vars';

//components
import CloudinaryPicture from 'components/CloudinaryPicture';
import Icon from 'components/Icon';
import Link from 'components/Link';

export const InstructionRowStatic = styled.div`
  align-items: center;
  background: #fff;
  display: flex;
  padding: 0.5rem;

  ${p =>
    p.device === 'desktop' &&
    `
    ${cardShadowCss(p.isLink)}
    border-radius: ${borderRadius.desktop}px;
  `}
`;

export const InstructionRowLink = InstructionRowStatic.withComponent(Link);

export const StyledCloudinaryPicture = styled(CloudinaryPicture).attrs({
  aspectRatio: 4 / 3,
  sizes: '84px'
})`
  flex-shrink: 0;
  width: 84px;
`;

export const ContentWrapper = styled.div`
  flex-grow: 1;
  margin-left: 1rem;
  overflow: hidden;
`;

export const Chevron = styled(Icon).attrs({
  name: 'chevron-right'
})`
  display: block;
  flex-shrink: 0;
  margin-left: 1rem;
  opacity: 0.2;
`;

export const HeadingWrapper = styled.div`
  display: flex;
`;

export const ChecklistIcon = styled(Icon).attrs({
  name: 'checklist',
  size: 26
})`
  margin: 0 8px 0 -8px;
`;
